import React from 'react';
import PropTypes from 'prop-types';
import CustomPortal from '../../commonComponents/CustomPortal';
import { SkippedPayoutsTable } from './SkippedPayoutsTable';
import { COLORS } from './constants';
import { Colors } from '../../../themes/colors';

export const PayoutSummaryStep = ({ result, onClose }) => (
  <CustomPortal
    title="Payout Submitted"
    submitText="Done"
    submitPressed={onClose}
    cancelPressed={onClose}
    hideLeftButton
    containerStyle={{ maxWidth: 560, width: '90vw' }}
  >
    <div style={{ width: '100%' }}>
      <p style={{ textAlign: 'center', color: COLORS.text, fontSize: 16 }}>
        <strong>{result.queued}</strong> payout
        {result.queued === 1 ? '' : 's'} queued for processing.
      </p>

      {result.skipped.length > 0 && (
        <>
          <p style={{ color: COLORS.text, marginTop: 16 }}>
            {result.skipped.length} row
            {result.skipped.length === 1 ? '' : 's'} skipped:
          </p>
          <SkippedPayoutsTable rows={result.skipped} />
        </>
      )}

      <p style={{ color: Colors.neutral_500, fontSize: 13, marginTop: 16, textAlign: 'center' }}>
        Transfers process asynchronously — the final succeeded / failed counts
        and reports appear in the promotion’s history.
      </p>
    </div>
  </CustomPortal>
);

PayoutSummaryStep.propTypes = {
  result: PropTypes.shape({
    queued: PropTypes.number,
    skipped: PropTypes.arrayOf(
      PropTypes.shape({ professionalId: PropTypes.string, reason: PropTypes.string }),
    ),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};
